export const gatewayList = ['Stripe', 'Paypal', 'Braintree', 'Tranzilla']

export const isUsingPaypal = el => el.payment_gateway === 'Paypal';
export const isUsingStripe = el => el.payment_gateway === 'Stripe';
export const isUsingBraintree = el => el.payment_gateway === 'Braintree';
